
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("7xXvm", function(module, exports) {

$parcel$export(module.exports, "ProfileCard", () => $329dd4b85ed15d85$export$bed540ccfa8743c4);
$parcel$export(module.exports, "default", () => $329dd4b85ed15d85$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bILK0 = parcelRequire("bILK0");

var $4xbv3 = parcelRequire("4xbv3");

var $lcB5K = parcelRequire("lcB5K");

var $lRq8t = parcelRequire("lRq8t");

var $8q7lT = parcelRequire("8q7lT");

var $7jTnu = parcelRequire("7jTnu");

var $bJscI = parcelRequire("bJscI");

var $1KdDN = parcelRequire("1KdDN");


var $lFp9s = parcelRequire("lFp9s");

var $38H79 = parcelRequire("38H79");

var $28Csj = parcelRequire("28Csj");
const $329dd4b85ed15d85$var$ConditionalErrorBoundary = (0, $bJscI.componentWithFG)('empanada_profilecard_sync_trigger_import_final', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "profilecard",
        packageName: (0, $6d22448f78a7f25a$export$9345d7360ffe0722),
        fallback: "flag"
    }, children), (0, $eJOHy.Fragment));
const $329dd4b85ed15d85$export$bed540ccfa8743c4 = ({ externalProfileClient: externalProfileClient, accountId: accountId, actions: actions, analyticsData: analyticsData, children: children, position: position, testId: testId, trigger: trigger, prepopulatedData: prepopulatedData, ariaHideProfileTrigger: ariaHideProfileTrigger, isChildComment: isChildComment = false, shouldTruncate: shouldTruncate = false })=>{
    const intl = (0, $lRq8t.default)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    const currentUserAccountId = (0, $8q7lT.useAccountId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($329dd4b85ed15d85$var$ConditionalErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        sourceName: (0, $6d22448f78a7f25a$export$81319ffa9c0d18d7),
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lFp9s.ProfileCardWrapper), {
        externalProfileClient: externalProfileClient
    }, currentUserAccountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lcB5K.RouterActions), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $28Csj.ProfileCardView), {
            accountId: accountId,
            actions: // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $7jTnu.fg)('jira_nin_smart_link') && (0, $7jTnu.fg)('jsc_nin_smart_link_fast_follows') ? (0, $38H79.getSpaActions)(accountId, intl, actions) : (0, $38H79.getSpaActionsWithRouterPush)(accountId, intl, push, actions),
            position: position,
            onProfileClick: (profileAccountId)=>push(`/jira/people/${profileAccountId}`),
            addFlag: showFlag,
            dismissFlag: dismissFlag,
            testId: testId,
            trigger: trigger,
            prepopulatedData: prepopulatedData,
            ariaHideProfileTrigger: ariaHideProfileTrigger,
            isChildComment: isChildComment,
            shouldTruncate: shouldTruncate
        }, children)) : children)));
};
var $329dd4b85ed15d85$export$2e2bcd8739ae039 = $329dd4b85ed15d85$export$bed540ccfa8743c4;

});
// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

const $6d22448f78a7f25a$export$9345d7360ffe0722 = 'jira-profilecard-next';
const $6d22448f78a7f25a$export$81319ffa9c0d18d7 = 'profileCardNext';
const $6d22448f78a7f25a$export$50632e21ea714398 = 'profileCardNextLegacy';
const $6d22448f78a7f25a$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $6d22448f78a7f25a$export$23cedd3261bd8015 = 'viewProfile';
const $6d22448f78a7f25a$export$6bef782d14a92db8 = 'assignedIssues';
const $6d22448f78a7f25a$export$6b36f20db7a18a86 = 'reportedIssues';
const $6d22448f78a7f25a$export$56da0dd0b0aa67b9 = 'viewFilters';

parcelRegister("lFp9s", function(module, exports) {

$parcel$export(module.exports, "ProfileCardWrapper", () => $298aff9366b0951f$export$59abd6feb7dc8540);

var $eJOHy = parcelRequire("eJOHy");

var $kEUB1 = parcelRequire("kEUB1");

var $8q7lT = parcelRequire("8q7lT");

var $9hopi = parcelRequire("9hopi");

var $9yGgq = parcelRequire("9yGgq");

var $16TBK = parcelRequire("16TBK");
const $298aff9366b0951f$export$59abd6feb7dc8540 = ({ externalProfileClient: externalProfileClient, children: children, onLoadError: onLoadError })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const accountId = (0, $8q7lT.useAccountId)();
    const fabricPfDirUrl = (0, $9yGgq.useFabricProfileDirectoryUrl)();
    const orgId = (0, $9hopi.useOrgId)();
    if (accountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16TBK.ProfileClientContainer), {
        fabricPfDirUrl: fabricPfDirUrl,
        profileClient: externalProfileClient || null,
        onLoadError: onLoadError,
        cloudId: cloudId,
        // Only use the global store when no external client is provided
        isGlobal: !externalProfileClient,
        orgId: orgId
    }, children);
    // When there is no tenantContext, this will cause the child
    // component of <ProfileCard> to render without being wrapped by
    // a profile card and it will do nothing on hover
    return children;
};

});
parcelRegister("9hopi", function(module, exports) {

$parcel$export(module.exports, "useOrgId", () => $854fde3141521561$export$52a03a3207af3687);

var $lvKO5 = parcelRequire("lvKO5");
const $854fde3141521561$export$52a03a3207af3687 = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.orgId;
};

});

parcelRegister("9yGgq", function(module, exports) {

$parcel$export(module.exports, "useFabricProfileDirectoryUrl", () => $3671ddc1abbfe28d$export$cb9379d435214a54);

var $lvKO5 = parcelRequire("lvKO5");
const $3671ddc1abbfe28d$export$cb9379d435214a54 = ()=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    return tenantContext && tenantContext.fabricPfDirUrl || '';
};

});

parcelRegister("16TBK", function(module, exports) {

$parcel$export(module.exports, "createUserProfileCardClient", () => $ca869b060f836c8a$export$c4393c51e6d104c3);
$parcel$export(module.exports, "ProfileClientContainer", () => $ca869b060f836c8a$export$d816ba2709570028);
$parcel$export(module.exports, "useProfileClient", () => $ca869b060f836c8a$export$d43dc22a8337ee9f);

var $d5fwz = parcelRequire("d5fwz");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $aBTmI = parcelRequire("aBTmI");
const $ca869b060f836c8a$var$GATEWAY_GRAPHQL_URL = '/gateway/api/graphql';
const $ca869b060f836c8a$export$c4393c51e6d104c3 = (fabricPfDirUrl, onLoadError, gatewayGraphqlUrl, cloudId, orgId)=>{
    const userClient = new (0, $aBTmI.CustomUserProfileClient)(fabricPfDirUrl, onLoadError);
    // From upward version 14 of `@atlaskit/profilecard`, `ProfileClient` class accepts `userClient` and `teamClient` in the 2nd argument.
    return new (0, $d5fwz.default)({
        cacheMaxAge: 180000,
        cacheSize: 20,
        url: fabricPfDirUrl,
        productIdentifier: 'jira',
        gatewayGraphqlUrl: gatewayGraphqlUrl,
        cloudId: cloudId,
        orgId: orgId
    }, {
        userClient: userClient
    });
};
const $ca869b060f836c8a$export$e324594224ef24da = {
    bootstrap: ()=>({ setState: setState }, { fabricPfDirUrl: fabricPfDirUrl, profileClient: profileClient, onLoadError: onLoadError, cloudId: cloudId, orgId: orgId })=>{
            const finalProfileClient = profileClient || $ca869b060f836c8a$export$c4393c51e6d104c3(fabricPfDirUrl ?? '', onLoadError, $ca869b060f836c8a$var$GATEWAY_GRAPHQL_URL, cloudId, orgId);
            setState({
                profileClient: finalProfileClient
            });
        }
};
const $ca869b060f836c8a$export$d816ba2709570028 = (0, $6E16M.createContainer)({
    displayName: 'ProfileClientContainer'
});
const $ca869b060f836c8a$export$d4c72bab9d6cc13a = {
    profileClient: null
};
const $ca869b060f836c8a$export$6f57813fe9f31bf9 = (0, $GtRbT.createStore)({
    name: 'ProfileClientStore',
    initialState: $ca869b060f836c8a$export$d4c72bab9d6cc13a,
    actions: $ca869b060f836c8a$export$e324594224ef24da,
    containedBy: $ca869b060f836c8a$export$d816ba2709570028,
    handlers: {
        onInit: ()=>({ dispatch: dispatch })=>dispatch($ca869b060f836c8a$export$e324594224ef24da.bootstrap())
    }
});
const $ca869b060f836c8a$export$d43dc22a8337ee9f = (0, $iJq0l.createStateHook)($ca869b060f836c8a$export$6f57813fe9f31bf9);

});
parcelRegister("d5fwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f71266daf2e15d5$export$2e2bcd8739ae039);


var $9PyvN = parcelRequire("9PyvN");


var $9uvjI = parcelRequire("9uvjI");
var $5f71266daf2e15d5$export$2e2bcd8739ae039 = (0, $9PyvN.default);

});
parcelRegister("9PyvN", function(module, exports) {

$parcel$export(module.exports, "default", () => $495edb629a854866$export$2e2bcd8739ae039);

var $8RHPx = parcelRequire("8RHPx");
var $lopBx = parcelRequire("lopBx");

var $bRjww = parcelRequire("bRjww");

var $49UfM = parcelRequire("49UfM");

var $52RFj = parcelRequire("52RFj");

var $9uvjI = parcelRequire("9uvjI");
const $495edb629a854866$var$defaultConfig = {
    gatewayGraphqlUrl: '/gateway/api/graphql'
};
class $495edb629a854866$var$ProfileCardClient {
    constructor(config, clients){
        //This default can be removed once all the clients are updated to pass the gatewayGraphqlUrl
        const withDefaultConfig = {
            ...$495edb629a854866$var$defaultConfig,
            ...config,
            gatewayGraphqlUrl: config.gatewayGraphqlUrl ?? $495edb629a854866$var$defaultConfig.gatewayGraphqlUrl
        };
        this.userClient = clients?.userClient || new (0, $9uvjI.default)(withDefaultConfig);
        this.teamClient = clients?.teamClient || new (0, $52RFj.default)(withDefaultConfig);
        this.rovoAgentClient = clients?.rovoAgentClient || new (0, $bRjww.default)(withDefaultConfig);
        this.tcClient = $495edb629a854866$var$maybeCreateTeamCentralClient(withDefaultConfig, clients);
    }
    flushCache() {
        this.userClient.flushCache();
        this.teamClient.flushCache();
        this.tcClient?.flushCache();
        this.rovoAgentClient?.flushCache();
    }
    getProfile(cloudId, userId, analytics) {
        return this.userClient.getProfile(cloudId, userId, analytics);
    }
    getTeamProfile(teamId, orgId, analytics) {
        return this.teamClient.getProfile(teamId, orgId, analytics);
    }
    getReportingLines(userId) {
        return this.tcClient?.getReportingLines(userId) || Promise.resolve({
            managers: [],
            reports: []
        });
    }
    async getTeamCentralBaseUrl(teamCentralScopes) {
        if (this.tcClient === undefined) return Promise.resolve(undefined);
        const isGlobalExperienceWorkspace = await this.tcClient.getIsGlobalExperienceWorkspace();
        if (!isGlobalExperienceWorkspace) return Promise.resolve((0, $8RHPx.getATLContextUrl)('team'));
        let suffix = '';
        if (teamCentralScopes !== undefined) {
            const orgId = await this.tcClient.getOrgId();
            if (orgId === null) return Promise.resolve(undefined);
            suffix += `/o/${orgId}`;
            if (teamCentralScopes.withSiteContext) suffix += `/s/${this.tcClient.options.cloudId}`;
        }
        return Promise.resolve(`${(0, $8RHPx.getATLContextUrl)('home')}${suffix}`);
    }
    async shouldShowGiveKudos() {
        if (!this.tcClient || !await this.getTeamCentralBaseUrl()) return Promise.resolve(false);
        return this.tcClient.checkWorkspaceExists();
    }
    getRovoAgentProfile(id, analytics) {
        return this.rovoAgentClient?.getProfile(id, analytics);
    }
    getRovoAgentPermissions(id, fireAnalytics) {
        return this.rovoAgentClient?.getPermissions(id, fireAnalytics);
    }
    deleteAgent(id, analytics) {
        return this.rovoAgentClient?.deleteAgent(id, analytics);
    }
    setFavouriteAgent(id, isFavourite, analytics) {
        return this.rovoAgentClient?.setFavouriteAgent(id, isFavourite, analytics);
    }
}
function $495edb629a854866$var$maybeCreateTeamCentralClient(config, clients) {
    if ((0, $lopBx.isFedRamp)()) return undefined;
    if (clients?.teamCentralClient) return clients.teamCentralClient;
    const teamCentralEnabled = config.teamCentralDisabled !== true;
    return teamCentralEnabled ? new (0, $49UfM.default)({
        ...config
    }) : undefined;
}
var $495edb629a854866$export$2e2bcd8739ae039 = $495edb629a854866$var$ProfileCardClient;

});
parcelRegister("bRjww", function(module, exports) {

$parcel$export(module.exports, "default", () => $05e8b6328c708954$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $2EPX4 = parcelRequire("2EPX4");

var $kNQN4 = parcelRequire("kNQN4");

var $fqVaP = parcelRequire("fqVaP");

var $2stUb = parcelRequire("2stUb");
const $05e8b6328c708954$var$createHeaders = (product, cloudId, isBodyJson)=>{
    const headers = new Headers({
        'X-Product': product,
        'X-Experience-Id': 'profile-card',
        'X-Cloudid': cloudId || ''
    });
    if (isBodyJson) headers.set('Content-Type', 'application/json');
    return headers;
};
class $05e8b6328c708954$export$2e2bcd8739ae039 extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    basePath() {
        return (0, $eGOwo.fg)('pt-deprecate-assistance-service') ? '/gateway/api/assist/rovo/v1/agents' : '/gateway/api/assist/agents/v1';
    }
    makeRequest(id, cloudId) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId);
        if (id.type === 'identity') return fetch(new Request(`${this.basePath()}/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
        return fetch(new Request(`${this.basePath()}/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>response.json());
    }
    getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('triggered'));
            this.makeRequest(id, this.options.cloudId || '').then((data)=>{
                if (this.cache) this.setCachedProfile(id.value, data);
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('succeeded', 'request', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('failed', 'request', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('triggered'));
            const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`${this.basePath()}/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('succeeded', 'deleteAgent', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('failed', 'deleteAgent', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('triggered', 'actionSubjectId'));
            const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`${this.basePath()}/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('succeeded', actionSubjectId, {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve();
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.agentRequestAnalytics)('failed', actionSubjectId, {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
    getPermissions(id, fireAnalytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (fireAnalytics) fireAnalytics((0, $2EPX4.agentRequestAnalytics)('triggered'));
            const headers = $05e8b6328c708954$var$createHeaders(product, this.options.cloudId, true);
            fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: headers,
                body: JSON.stringify({
                    permission_ids: [
                        'AGENT_CREATE',
                        'AGENT_UPDATE',
                        'AGENT_DELETE',
                        'AGENT_DEACTIVATE',
                        'AGENT_READ'
                    ]
                })
            })).then((response)=>response.json()).then((data)=>{
                if (fireAnalytics) fireAnalytics((0, $2EPX4.agentRequestAnalytics)('succeeded', 'getAgentPermissions', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (fireAnalytics) fireAnalytics((0, $2EPX4.agentRequestAnalytics)('failed', 'getAgentPermissions', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("2EPX4", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $7d8a130fd15a8bb5$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $7d8a130fd15a8bb5$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $7d8a130fd15a8bb5$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $7d8a130fd15a8bb5$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $7d8a130fd15a8bb5$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $7d8a130fd15a8bb5$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $7d8a130fd15a8bb5$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $7d8a130fd15a8bb5$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $7d8a130fd15a8bb5$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $7d8a130fd15a8bb5$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $7d8a130fd15a8bb5$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $7d8a130fd15a8bb5$export$a9f8c9f412cf5664);

var $kNQN4 = parcelRequire("kNQN4");
/** Below lines are copied from teams common analytics */ const $7d8a130fd15a8bb5$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $7d8a130fd15a8bb5$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $7d8a130fd15a8bb5$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $7d8a130fd15a8bb5$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($7d8a130fd15a8bb5$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $7d8a130fd15a8bb5$var$TEAM_SUBJECT = 'teamProfileCard';
const $7d8a130fd15a8bb5$var$USER_SUBJECT = 'profilecard';
const $7d8a130fd15a8bb5$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
const $7d8a130fd15a8bb5$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $kNQN4.getPageTime)())
        }
    });
const $7d8a130fd15a8bb5$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $7d8a130fd15a8bb5$var$USER_SUBJECT;
        case 'team':
            return $7d8a130fd15a8bb5$var$TEAM_SUBJECT;
        case 'agent':
            return $7d8a130fd15a8bb5$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $7d8a130fd15a8bb5$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $7d8a130fd15a8bb5$var$createEvent('ui', 'triggered', $7d8a130fd15a8bb5$var$getActionSubject(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $7d8a130fd15a8bb5$export$c9b0e37b229a297b = (action, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'request', attributes);
const $7d8a130fd15a8bb5$export$12dae48763368ac9 = (action, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$USER_SUBJECT, 'request', attributes);
const $7d8a130fd15a8bb5$export$41816a317479160b = (type, actionSubjectId, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'rendered', $7d8a130fd15a8bb5$var$getActionSubject(type), actionSubjectId, attributes);
const $7d8a130fd15a8bb5$export$fdcd134fbeb1f921 = (type, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$getActionSubject(type), 'action', attributes);
const $7d8a130fd15a8bb5$export$93260987012593be = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$USER_SUBJECT, 'reportingLines', attributes);
const $7d8a130fd15a8bb5$export$79befd155063a6a7 = (type, attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$getActionSubject(type), 'moreActions', attributes);
const $7d8a130fd15a8bb5$export$2703289b35687fde = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'avatar', attributes);
const $7d8a130fd15a8bb5$export$b4411a7661cf2d3f = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $7d8a130fd15a8bb5$export$c86679da702d560e = (attributes)=>$7d8a130fd15a8bb5$var$createEvent('ui', 'clicked', $7d8a130fd15a8bb5$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $7d8a130fd15a8bb5$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$7d8a130fd15a8bb5$var$createEvent('operational', action, $7d8a130fd15a8bb5$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("kNQN4", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $64b9704217d393a1$export$e9faea7c41053334);
const $64b9704217d393a1$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $64b9704217d393a1$var$performanceAvailable = $64b9704217d393a1$var$isPerformanceAvailable();
const $64b9704217d393a1$var$initialPageTime = Date.now();
const $64b9704217d393a1$export$e9faea7c41053334 = ()=>{
    if ($64b9704217d393a1$var$performanceAvailable) return performance.now();
    return Date.now() - $64b9704217d393a1$var$initialPageTime;
};

});


parcelRegister("fqVaP", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc90275f52a03ea7$export$2e2bcd8739ae039);

var $7xkt0 = parcelRequire("7xkt0");
class $cc90275f52a03ea7$export$2e2bcd8739ae039 {
    constructor(config){
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $7xkt0.LRUMap)(this.config.cacheSize);
    }
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
}

});

parcelRegister("2stUb", function(module, exports) {

$parcel$export(module.exports, "getErrorAttributes", () => $3d31a5950b175c26$export$6ad9e7706a4ee0f8);
$parcel$export(module.exports, "handleDirectoryGraphQLErrors", () => $3d31a5950b175c26$export$7642af465ceb7f05);
$parcel$export(module.exports, "handleAGGErrors", () => $3d31a5950b175c26$export$d9ad65d422ee3f8c);

var $as7HK = parcelRequire("as7HK");
const $3d31a5950b175c26$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $3d31a5950b175c26$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $3d31a5950b175c26$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $3d31a5950b175c26$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $as7HK.DirectoryGraphQLError)) return !!error && $3d31a5950b175c26$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $as7HK.AGGError)) return !!error.errorType && $3d31a5950b175c26$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $3d31a5950b175c26$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $3d31a5950b175c26$export$6ad9e7706a4ee0f8 = (error)=>{
    if (error instanceof (0, $as7HK.DirectoryGraphQLErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($3d31a5950b175c26$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($3d31a5950b175c26$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $as7HK.DirectoryGraphQLError)) return {
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber,
        isSLOFailure: !$3d31a5950b175c26$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $as7HK.AGGErrors)) return {
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($3d31a5950b175c26$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($3d31a5950b175c26$var$isIgnoredError),
        traceId: error.traceId
    };
    else if (error instanceof (0, $as7HK.AGGError)) return {
        errorMessage: error.message,
        errorType: error.errorType,
        errorStatusCode: error.statusCode,
        isSLOFailure: !$3d31a5950b175c26$var$isIgnoredError(error),
        errorCategory: error.classification
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $as7HK.DirectoryGraphQLErrors) || causeError instanceof (0, $as7HK.AGGErrors)) return $3d31a5950b175c26$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $3d31a5950b175c26$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $as7HK.DirectoryGraphQLErrors)(errors, traceId);
};
const $3d31a5950b175c26$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $as7HK.AGGErrors)(errors, traceId);
};

});
parcelRegister("as7HK", function(module, exports) {

$parcel$export(module.exports, "HttpError", () => $e980080011a8d765$export$65bd6083489bd8bb);
$parcel$export(module.exports, "DirectoryGraphQLError", () => $e980080011a8d765$export$c1e4d0de940c06a2);
$parcel$export(module.exports, "DirectoryGraphQLErrors", () => $e980080011a8d765$export$5a5fbfed34a590a1);
$parcel$export(module.exports, "AGGError", () => $e980080011a8d765$export$4a696f048dcc929);
$parcel$export(module.exports, "AGGErrors", () => $e980080011a8d765$export$60d8267243755b9c);
class $e980080011a8d765$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = code;
        this.traceId = traceId;
    }
}
class $e980080011a8d765$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $e980080011a8d765$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $e980080011a8d765$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $e980080011a8d765$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $e980080011a8d765$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $e980080011a8d765$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}

});



parcelRegister("49UfM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b519ebe8bdd19c29$export$2e2bcd8739ae039);

var $eGOwo = parcelRequire("eGOwo");

var $fqVaP = parcelRequire("fqVaP");

var $jjeHq = parcelRequire("jjeHq");

var $4qbZy = parcelRequire("4qbZy");
const $b519ebe8bdd19c29$var$UNSHARDED_PREFIX = '/gateway/api/watermelon';
const $b519ebe8bdd19c29$export$1862ef0c3880ca8d = (aaid)=>({
        query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
        variables: {
            aaid: aaid
        }
    });
const $b519ebe8bdd19c29$var$orgContainsAnyWorkspacePromiseCache = new Map();
const $b519ebe8bdd19c29$var$orgIdPromiseCache = new Map();
const $b519ebe8bdd19c29$var$workspaceExistsWithTypePromiseCache = new Map();
class $b519ebe8bdd19c29$var$TeamCentralCardClient extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
        this.bypassOnFailure = false;
        this.orgContainsAnyWorkspacePromise = this.createOrgContainsAnyWorkspacePromise(options);
        this.workspaceExistsWithTypePromise = this.preloadWorkspaceExistsWithType(options.cloudId);
        this.orgIdPromise = this.preloadOrgId(options.gatewayGraphqlUrl, options.cloudId, options.orgId);
    }
    createOrgContainsAnyWorkspacePromise(config) {
        if (config.cloudId) {
            let promise = $b519ebe8bdd19c29$var$orgContainsAnyWorkspacePromiseCache.get(config.cloudId);
            if (!promise) {
                promise = this.getOrgContainsAnyWorkspace(config.cloudId);
                $b519ebe8bdd19c29$var$orgContainsAnyWorkspacePromiseCache.set(config.cloudId, promise);
            }
            return promise;
        }
        return Promise.resolve(true);
    }
    getReportingLines(userId) {
        return this.orgContainsAnyWorkspacePromise.then((orgContainsAnyWorkspace)=>{
            if (orgContainsAnyWorkspace) {
                if (!userId) return Promise.reject(new Error('userId missing'));
                const cache = this.getCachedProfile(userId);
                if (cache) return Promise.resolve(cache);
                if (this.bypassOnFailure) return Promise.resolve({});
                return new Promise((resolve)=>{
                    this.makeRequest(userId).then((data)=>{
                        const enhancedData = {
                            managers: this.filterReportingLinesUser(data?.managers),
                            reports: this.filterReportingLinesUser(data?.reports)
                        };
                        if (this.cache) this.setCachedProfile(userId, enhancedData);
                        resolve(enhancedData);
                    }).catch((error)=>{
                        if (error?.status === 401 || error?.status === 403) // Trigger circuit breaker
                        this.bypassOnFailure = true;
                        /**
								 * Reporting lines aren't part of the critical path of profile card.
								 * Just resolve with empty values instead of bubbling up the error.
								 */ resolve({});
                    });
                });
            }
            return Promise.resolve({
                managers: [],
                reports: []
            });
        }, ()=>Promise.resolve({
                managers: [],
                reports: []
            }));
    }
    /**
	 * `public` so that mock client can override it; do not use it otherwise!
	 */ async makeRequest(userId) {
        if (this.options.teamCentralDisabled === true) throw new Error('makeRequest cannot be called when the client has been disabled');
        const query = $b519ebe8bdd19c29$export$1862ef0c3880ca8d(userId);
        const response = await (0, $4qbZy.directoryGraphqlQuery)('/gateway/api/watermelon/graphql?operationName=ReportingLines', query);
        return response.reportingLines;
    }
    async checkWorkspaceExists() {
        const workspaceExistsPromise = (0, $eGOwo.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? this.workspaceExistsWithTypePromise.then((workspaceExistsWithType)=>workspaceExistsWithType !== undefined) : this.orgContainsAnyWorkspacePromise;
        return workspaceExistsPromise.then((workspaceExistsWithType)=>{
            if (workspaceExistsWithType) return Promise.resolve(true);
            return Promise.resolve(false);
        }, ()=>Promise.resolve(false));
    }
    async getIsGlobalExperienceWorkspace() {
        return await this.workspaceExistsWithTypePromise === 'GLOBAL_EXPERIENCE';
    }
    getOrgId() {
        return this.orgIdPromise;
    }
    preloadWorkspaceExistsWithType(cloudId) {
        if (cloudId === undefined) return Promise.resolve(undefined);
        const maybeWorkspaceExistsWithTypePromise = $b519ebe8bdd19c29$var$workspaceExistsWithTypePromiseCache.get(cloudId);
        if (maybeWorkspaceExistsWithTypePromise !== undefined) return maybeWorkspaceExistsWithTypePromise;
        const workspaceExistsWithTypePromise = this.getWorkspaceExistsWithType(cloudId);
        $b519ebe8bdd19c29$var$workspaceExistsWithTypePromiseCache.set(cloudId, workspaceExistsWithTypePromise);
        return workspaceExistsWithTypePromise;
    }
    getOrgContainsAnyWorkspace(cloudId) {
        if (cloudId) return fetch(((0, $eGOwo.fg)('enable_ptc_townsquare_reporting_lines_unsharded') ? $b519ebe8bdd19c29$var$UNSHARDED_PREFIX : this.getShardedApiPath(cloudId)) + `/organization/containsAnyWorkspace?cloudId=${cloudId}`).then((res)=>{
            return !res || res && res.ok;
        });
        else return Promise.resolve(false);
    }
    async getWorkspaceExistsWithType(cloudId) {
        try {
            const response = await fetch(`${this.getShardedApiPath(cloudId)}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                credentials: 'include'
            });
            if (response.ok) {
                const workspaceType = await response.text();
                return Promise.resolve(workspaceType);
            }
        } catch (err) {
            return Promise.resolve(undefined);
        }
    }
    preloadOrgId(gatewayGraphqlUrl, cloudId, orgId) {
        if (cloudId === undefined) return Promise.resolve(null);
        if (orgId !== undefined) return Promise.resolve(orgId);
        const maybeOrgIdForCloudIdPromise = $b519ebe8bdd19c29$var$orgIdPromiseCache.get(cloudId);
        if (maybeOrgIdForCloudIdPromise !== undefined) return maybeOrgIdForCloudIdPromise;
        const orgIdForCloudIdPromise = (0, $jjeHq.getOrgIdForCloudIdFromAGG)(gatewayGraphqlUrl, cloudId);
        $b519ebe8bdd19c29$var$orgIdPromiseCache.set(cloudId, orgIdForCloudIdPromise);
        return orgIdForCloudIdPromise;
    }
    getShardedApiPath(cloudId) {
        return `/gateway/api/townsquare/s/${cloudId}`;
    }
    filterReportingLinesUser(users = []) {
        return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
    }
}
var $b519ebe8bdd19c29$export$2e2bcd8739ae039 = $b519ebe8bdd19c29$var$TeamCentralCardClient;

});
parcelRegister("jjeHq", function(module, exports) {

$parcel$export(module.exports, "getOrgIdForCloudIdFromAGG", () => $a1fbf8b2b4930fa8$export$d38a536fd806c68f);

var $4qbZy = parcelRequire("4qbZy");
const $a1fbf8b2b4930fa8$var$ORG_ID_FROM_CLOUD_ID_QUERY = `query OrgIdFromCloudId($cloudId: ID!) {
	tenantContexts(cloudIds: [$cloudId]) {
		orgId
	}
}`;
const $a1fbf8b2b4930fa8$var$addHeaders = (headers)=>{
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $a1fbf8b2b4930fa8$export$d38a536fd806c68f(url, cloudId) {
    const query = {
        query: $a1fbf8b2b4930fa8$var$ORG_ID_FROM_CLOUD_ID_QUERY,
        variables: {
            cloudId: cloudId
        }
    };
    try {
        const { tenantContexts: tenantContexts } = await (0, $4qbZy.AGGQuery)(url, query, $a1fbf8b2b4930fa8$var$addHeaders);
        if (!tenantContexts || tenantContexts.length === 0 || tenantContexts[0] === null) return null;
        return tenantContexts[0].orgId;
    } catch (err) {
        // don't bubble up the error, and let consumers handle it as if the cloud ID
        // doesn't resolve to an org ID
        return null;
    }
}

});
parcelRegister("4qbZy", function(module, exports) {

$parcel$export(module.exports, "directoryGraphqlQuery", () => $79a99a18e51eddf3$export$a5b5995619d4fe36);
$parcel$export(module.exports, "AGGQuery", () => $79a99a18e51eddf3$export$a14afb5f82fe705);

var $as7HK = parcelRequire("as7HK");

var $2stUb = parcelRequire("2stUb");
const $79a99a18e51eddf3$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $79a99a18e51eddf3$var$id = (headers)=>headers;
async function $79a99a18e51eddf3$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $79a99a18e51eddf3$var$id) {
    return $79a99a18e51eddf3$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $2stUb.handleDirectoryGraphQLErrors));
}
async function $79a99a18e51eddf3$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $79a99a18e51eddf3$var$id) {
    return $79a99a18e51eddf3$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $2stUb.handleAGGErrors));
}
async function $79a99a18e51eddf3$var$graphQLQuery(serviceUrl, query, processHeaders = $79a99a18e51eddf3$var$id, handleErrors) {
    const headers = processHeaders($79a99a18e51eddf3$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $as7HK.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}

});



parcelRegister("52RFj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8330ec0bc030b200$export$2e2bcd8739ae039);

var $2EPX4 = parcelRequire("2EPX4");

var $kNQN4 = parcelRequire("kNQN4");

var $fqVaP = parcelRequire("fqVaP");

var $2stUb = parcelRequire("2stUb");

var $7jwft = parcelRequire("7jwft");
class $8330ec0bc030b200$export$2e2bcd8739ae039 extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    makeRequest(teamId, _orgId) {
        if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
        return (0, $7jwft.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
    }
    getProfile(teamId, orgId, analytics) {
        if (!teamId) return Promise.reject(new Error('teamId is missing'));
        const cache = this.getCachedProfile(teamId);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            if (analytics) analytics((0, $2EPX4.teamRequestAnalytics)('triggered'));
            this.makeRequest(teamId, orgId).then((data)=>{
                if (this.cache) this.setCachedProfile(teamId, data);
                if (analytics) analytics((0, $2EPX4.teamRequestAnalytics)('succeeded', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    gateway: true
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.teamRequestAnalytics)('failed', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error),
                    gateway: true
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("7jwft", function(module, exports) {

$parcel$export(module.exports, "extractIdFromAri", () => $34e7bc800a4991e6$export$5816a09dbb711691);
$parcel$export(module.exports, "getTeamFromAGG", () => $34e7bc800a4991e6$export$26a8aad0c7182dd6);

var $4qbZy = parcelRequire("4qbZy");
const $34e7bc800a4991e6$var$ARI_PREFIX = 'ari:cloud:identity::team/';
const $34e7bc800a4991e6$export$5816a09dbb711691 = (ari)=>{
    const slashPos = ari.indexOf('/');
    const id = ari.slice(slashPos + 1);
    return id;
};
const $34e7bc800a4991e6$export$681597d03c8a0fd2 = (teamId)=>{
    return `ari:cloud:identity::team/${teamId}`;
};
const $34e7bc800a4991e6$export$7878e28c136af76 = (teamIdOrTeamAri)=>teamIdOrTeamAri.startsWith($34e7bc800a4991e6$var$ARI_PREFIX) ? teamIdOrTeamAri : $34e7bc800a4991e6$export$681597d03c8a0fd2(teamIdOrTeamAri);
const $34e7bc800a4991e6$export$fce1abb40bf8db94 = (result)=>{
    const { team: team } = result;
    return {
        ...team,
        id: $34e7bc800a4991e6$export$5816a09dbb711691(team.id),
        members: team.members?.nodes.map(({ member: member })=>({
                id: member.accountId,
                fullName: member.name,
                avatarUrl: member.picture
            }))
    };
};
// indented so it's
const $34e7bc800a4991e6$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
	  isVerified
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
const $34e7bc800a4991e6$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$34e7bc800a4991e6$var$TEAM_FRAGMENT}
    }
  }
}`;
const $34e7bc800a4991e6$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
        query: $34e7bc800a4991e6$export$4968f4e0119a5d9c,
        variables: {
            teamId: $34e7bc800a4991e6$export$7878e28c136af76(teamId),
            siteId: siteId || 'None'
        }
    });
const $34e7bc800a4991e6$export$1229c72526c01df2 = (headers)=>{
    headers.append('X-ExperimentalApi', 'teams-beta');
    headers.append('X-ExperimentalApi', 'team-members-beta');
    headers.append('atl-client-name', "platform-pkg");
    headers.append('atl-client-version', "0.0.0-use.local");
    return headers;
};
async function $34e7bc800a4991e6$export$26a8aad0c7182dd6(url, teamId, siteId) {
    const query = $34e7bc800a4991e6$export$695d743d1401e038({
        teamId: teamId,
        siteId: siteId
    });
    const { Team: Team } = await (0, $4qbZy.AGGQuery)(url, query, $34e7bc800a4991e6$export$1229c72526c01df2);
    return $34e7bc800a4991e6$export$fce1abb40bf8db94(Team);
}

});


parcelRegister("9uvjI", function(module, exports) {

$parcel$export(module.exports, "default", () => $467a485168b1cd0d$export$2e2bcd8739ae039);

var $6NFTG = parcelRequire("6NFTG");

var $kuAvn = parcelRequire("kuAvn");

var $eGOwo = parcelRequire("eGOwo");

var $2EPX4 = parcelRequire("2EPX4");

var $hX5cm = parcelRequire("hX5cm");

var $kNQN4 = parcelRequire("kNQN4");

var $fqVaP = parcelRequire("fqVaP");

var $2stUb = parcelRequire("2stUb");

var $4qbZy = parcelRequire("4qbZy");
const $467a485168b1cd0d$export$b26b7f9bcf400835 = (response)=>{
    const data = {
        ...response.User
    };
    const localWeekdayIndex = new Date().getDay().toString();
    if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
    return {
        isBot: data.isBot,
        isCurrentUser: data.isCurrentUser,
        status: data.status,
        statusModifiedDate: data.statusModifiedDate || undefined,
        avatarUrl: data.avatarUrl || undefined,
        email: data.email || undefined,
        fullName: data.fullName || undefined,
        location: data.location || undefined,
        meta: data.meta || undefined,
        nickname: data.nickname || undefined,
        companyName: data.companyName || undefined,
        timestring: data.remoteTimeString || undefined,
        accountType: data.accountType || undefined
    };
};
const $467a485168b1cd0d$var$aggUserQuery = (0, $kuAvn.default)`
	query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
				appType
			}
		}
	}
`;
const $467a485168b1cd0d$var$aggUserQueryString = `query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
      			appType
    		}
		}
	}`;
const $467a485168b1cd0d$export$8230f28f7ae567ea = (userId)=>({
        query: (0, $eGOwo.fg)('platform_agg_user_query_doc_change') ? (0, $6NFTG.print)($467a485168b1cd0d$var$aggUserQuery) : $467a485168b1cd0d$var$aggUserQueryString,
        variables: {
            userId: userId
        }
    });
const $467a485168b1cd0d$var$queryAGGUser = async (url, userId)=>{
    const query = $467a485168b1cd0d$export$8230f28f7ae567ea(userId);
    const { user: user } = await (0, $4qbZy.AGGQuery)(url, query);
    return user;
};
class $467a485168b1cd0d$export$2e2bcd8739ae039 extends (0, $fqVaP.default) {
    constructor(options){
        super(options);
        this.options = options;
    }
    async makeRequest(cloudId, userId) {
        const gatewayGraphqlUrl = this.options.gatewayGraphqlUrl || '/gateway/api/graphql';
        const urlWithOperationName = `${gatewayGraphqlUrl}?operationName=aggUserQuery`;
        const userQueryPromise = $467a485168b1cd0d$var$queryAGGUser(urlWithOperationName, userId);
        const user = await userQueryPromise;
        let timestring;
        const localWeekdayIndex = new Date().getDay().toString();
        const timeFormat = (0, $eGOwo.fg)('platform_profilecard-update-time-format') ? 'h:mmaaa' : 'h:mmbbb';
        if (user.zoneinfo) {
            if ((0, $hX5cm.localTime)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $hX5cm.localTime)(user.zoneinfo, timeFormat) || undefined;
            else timestring = (0, $hX5cm.localTime)(user.zoneinfo, `eee ${timeFormat}`) || undefined;
        }
        return {
            ...user,
            isBot: user.__typename === 'AppUser',
            isAgent: user.appType === 'agent',
            isServiceAccount: user.__typename === 'AppUser' && user.appType === 'service',
            status: user.accountStatus,
            statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
            avatarUrl: user.picture,
            email: user.email,
            fullName: user.name,
            location: user.extendedProfile?.location,
            meta: user.extendedProfile?.jobTitle,
            nickname: user.nickname,
            companyName: user.extendedProfile?.organization,
            timestring: timestring
        };
    }
    getProfile(cloudId, userId, analytics) {
        if (!userId) return Promise.reject(new Error('userId missing'));
        const cacheIdentifier = `${cloudId}/${userId}`;
        const cache = this.getCachedProfile(cacheIdentifier);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $kNQN4.getPageTime)();
            if (analytics) analytics((0, $2EPX4.userRequestAnalytics)('triggered'));
            this.makeRequest(cloudId, userId).then((data)=>{
                if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                if (analytics) analytics((0, $2EPX4.userRequestAnalytics)('succeeded', {
                    duration: (0, $kNQN4.getPageTime)() - startTime
                }));
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics((0, $2EPX4.userRequestAnalytics)('failed', {
                    duration: (0, $kNQN4.getPageTime)() - startTime,
                    ...(0, $2stUb.getErrorAttributes)(error)
                }));
                reject(error);
            });
        });
    }
}

});
parcelRegister("hX5cm", function(module, exports) {

$parcel$export(module.exports, "localTime", () => $98ebf9c8b6385a65$export$f0dfd716e7b023cd);
parcelRequire("7XJii");
var $iLEEy = parcelRequire("iLEEy");
const $98ebf9c8b6385a65$export$f0dfd716e7b023cd = (timezone, format)=>{
    if (!timezone) return null;
    try {
        return (0, $iLEEy.default)(new Date(), timezone, format);
    } catch (error) {
        return null;
    }
};

});
parcelRegister("7XJii", function(module, exports) {

$parcel$export(module.exports, "formatInTimeZone", () => (parcelRequire("iLEEy")).default);
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.


var $iLEEy = parcelRequire("iLEEy");





});
parcelRegister("iLEEy", function(module, exports) {

$parcel$export(module.exports, "default", () => $da9c26a946bf047b$export$2e2bcd8739ae039);

var $7noXc = parcelRequire("7noXc");

var $a4wuW = parcelRequire("a4wuW");

var $iEVvn = parcelRequire("iEVvn");
function $da9c26a946bf047b$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($7noXc)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $a4wuW.default)((0, $iEVvn.default)(date, timeZone), formatStr, extendedOptions);
}

});
parcelRegister("a4wuW", function(module, exports) {

$parcel$export(module.exports, "default", () => $75537c87aa32bbea$export$2e2bcd8739ae039);

var $47etr = parcelRequire("47etr");

var $jn1Yb = parcelRequire("jn1Yb");

var $bWiNt = parcelRequire("bWiNt");
var $75537c87aa32bbea$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $75537c87aa32bbea$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($75537c87aa32bbea$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $bWiNt.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $jn1Yb.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($47etr)))(dirtyDate, formatStr, options);
}

});
parcelRegister("jn1Yb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a1b16befdfb889$export$2e2bcd8739ae039);

var $emmbH = parcelRequire("emmbH");

var $a2zuC = parcelRequire("a2zuC");
var $e1a1b16befdfb889$var$MILLISECONDS_IN_MINUTE = 60000;
var $e1a1b16befdfb889$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $e1a1b16befdfb889$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $e1a1b16befdfb889$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $e1a1b16befdfb889$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $e1a1b16befdfb889$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $e1a1b16befdfb889$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $e1a1b16befdfb889$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $e1a1b16befdfb889$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $e1a1b16befdfb889$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $emmbH.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $emmbH.default)('long', date, options);
        }
    }
};
function $e1a1b16befdfb889$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $a2zuC.default)(timeZone, originalDate, true) / $e1a1b16befdfb889$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $e1a1b16befdfb889$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $e1a1b16befdfb889$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $e1a1b16befdfb889$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $e1a1b16befdfb889$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $e1a1b16befdfb889$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $e1a1b16befdfb889$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $e1a1b16befdfb889$var$formatTimezone(offset, dirtyDelimeter);
}
function $e1a1b16befdfb889$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $e1a1b16befdfb889$var$addLeadingZeros(minutes, 2);
}
var $e1a1b16befdfb889$export$2e2bcd8739ae039 = $e1a1b16befdfb889$var$formatters;

});
parcelRegister("emmbH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a74454c810e10efc$export$2e2bcd8739ae039);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $a74454c810e10efc$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $a74454c810e10efc$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $a74454c810e10efc$var$partsTimeZone(dtf, date) : $a74454c810e10efc$var$hackyTimeZone(dtf, date);
}
function $a74454c810e10efc$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $a74454c810e10efc$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $a74454c810e10efc$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

});

parcelRegister("a2zuC", function(module, exports) {

$parcel$export(module.exports, "default", () => $74f59f73042f5ea2$export$2e2bcd8739ae039);

var $iKmlv = parcelRequire("iKmlv");

var $eMjjs = parcelRequire("eMjjs");
var $74f59f73042f5ea2$var$MILLISECONDS_IN_HOUR = 3600000;
var $74f59f73042f5ea2$var$MILLISECONDS_IN_MINUTE = 60000;
var $74f59f73042f5ea2$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $74f59f73042f5ea2$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $74f59f73042f5ea2$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $74f59f73042f5ea2$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$74f59f73042f5ea2$var$validateTimezone(hours)) return NaN;
        return -(hours * $74f59f73042f5ea2$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $74f59f73042f5ea2$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$74f59f73042f5ea2$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $74f59f73042f5ea2$var$MILLISECONDS_IN_HOUR + minutes * $74f59f73042f5ea2$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($74f59f73042f5ea2$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $74f59f73042f5ea2$var$toUtcDate(date);
        var offset = $74f59f73042f5ea2$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $74f59f73042f5ea2$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $74f59f73042f5ea2$var$toUtcDate(date) {
    return (0, $eMjjs.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $74f59f73042f5ea2$var$calcOffset(date, timezoneString) {
    var tokens = (0, $iKmlv.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $eMjjs.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $74f59f73042f5ea2$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $74f59f73042f5ea2$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $74f59f73042f5ea2$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $74f59f73042f5ea2$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $74f59f73042f5ea2$var$validIANATimezoneCache = {};
function $74f59f73042f5ea2$var$isValidTimezoneIANAString(timeZoneString) {
    if ($74f59f73042f5ea2$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $74f59f73042f5ea2$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

});
parcelRegister("iKmlv", function(module, exports) {

$parcel$export(module.exports, "default", () => $da5ddb5213ce8f83$export$2e2bcd8739ae039);
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $da5ddb5213ce8f83$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $da5ddb5213ce8f83$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $da5ddb5213ce8f83$var$partsOffset(dtf, date) : $da5ddb5213ce8f83$var$hackyOffset(dtf, date);
}
var $da5ddb5213ce8f83$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $da5ddb5213ce8f83$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $da5ddb5213ce8f83$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $da5ddb5213ce8f83$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $da5ddb5213ce8f83$var$dtfCache = {};
function $da5ddb5213ce8f83$var$getDateTimeFormat(timeZone) {
    if (!$da5ddb5213ce8f83$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $da5ddb5213ce8f83$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $da5ddb5213ce8f83$var$dtfCache[timeZone];
}

});

parcelRegister("eMjjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac2487857a682a48$export$2e2bcd8739ae039);
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $ac2487857a682a48$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

});



parcelRegister("bWiNt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b13b1308e9ec166$export$2e2bcd8739ae039);

var $a04h3 = parcelRequire("a04h3");

var $ejJXr = parcelRequire("ejJXr");

var $a2zuC = parcelRequire("a2zuC");

var $cIjNZ = parcelRequire("cIjNZ");
var $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR = 3600000;
var $8b13b1308e9ec166$var$MILLISECONDS_IN_MINUTE = 60000;
var $8b13b1308e9ec166$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $8b13b1308e9ec166$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $cIjNZ.default)
};
function $8b13b1308e9ec166$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $8b13b1308e9ec166$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($a04h3)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $8b13b1308e9ec166$var$splitDateString(argument);
    var parseYearResult = $8b13b1308e9ec166$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $8b13b1308e9ec166$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $8b13b1308e9ec166$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $a2zuC.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($ejJXr)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $8b13b1308e9ec166$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $8b13b1308e9ec166$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $8b13b1308e9ec166$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $8b13b1308e9ec166$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $8b13b1308e9ec166$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $8b13b1308e9ec166$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $8b13b1308e9ec166$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $8b13b1308e9ec166$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $8b13b1308e9ec166$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $8b13b1308e9ec166$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $8b13b1308e9ec166$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$8b13b1308e9ec166$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $8b13b1308e9ec166$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$8b13b1308e9ec166$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $8b13b1308e9ec166$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$8b13b1308e9ec166$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $8b13b1308e9ec166$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$8b13b1308e9ec166$var$validateWeekDate(year, week)) return new Date(NaN);
        return $8b13b1308e9ec166$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $8b13b1308e9ec166$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$8b13b1308e9ec166$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $8b13b1308e9ec166$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $8b13b1308e9ec166$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $8b13b1308e9ec166$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$8b13b1308e9ec166$var$validateTime(hours)) return NaN;
        return hours % 24 * $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $8b13b1308e9ec166$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$8b13b1308e9ec166$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR + minutes * $8b13b1308e9ec166$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $8b13b1308e9ec166$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$8b13b1308e9ec166$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $8b13b1308e9ec166$var$MILLISECONDS_IN_HOUR + minutes * $8b13b1308e9ec166$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $8b13b1308e9ec166$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $8b13b1308e9ec166$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $8b13b1308e9ec166$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $8b13b1308e9ec166$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $8b13b1308e9ec166$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $8b13b1308e9ec166$var$isLeapYearIndex(year);
        if (isLeapYear && date > $8b13b1308e9ec166$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $8b13b1308e9ec166$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $8b13b1308e9ec166$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $8b13b1308e9ec166$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $8b13b1308e9ec166$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $8b13b1308e9ec166$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

});
parcelRegister("cIjNZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9418f4fd702d1312$export$2e2bcd8739ae039);
/** Regex to identify the presence of a time zone specifier in a date string */ var $9418f4fd702d1312$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $9418f4fd702d1312$export$2e2bcd8739ae039 = $9418f4fd702d1312$var$tzPattern;

});



parcelRegister("iEVvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d95891bc4ee0ba6d$export$2e2bcd8739ae039);

var $a2zuC = parcelRequire("a2zuC");

var $bWiNt = parcelRequire("bWiNt");
function $d95891bc4ee0ba6d$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $bWiNt.default)(dirtyDate, options);
    var offsetMilliseconds = (0, $a2zuC.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

});







parcelRegister("aBTmI", function(module, exports) {

$parcel$export(module.exports, "CustomUserProfileClient", () => $21d1f3a214a5c794$export$4b2a86afb64f42f1);

var $9uvjI = parcelRequire("9uvjI");

var $1Ozm9 = parcelRequire("1Ozm9");

var $38H79 = parcelRequire("38H79");
class $21d1f3a214a5c794$export$4b2a86afb64f42f1 extends (0, $9uvjI.default) {
    constructor(fabricPfDirUrl, onLoadError){
        super({
            url: fabricPfDirUrl,
            cacheSize: 20,
            cacheMaxAge: 180000
        }), this.makeRequest = async (cloudId, userId)=>{
            // call old profile rest endpoint
            try {
                if ((0, $38H79.isCustomerAccount)(userId)) {
                    const response = await (0, $1Ozm9.default)(`/rest/api/3/user?accountId=${userId}`);
                    return (0, $38H79.restResponseToUserData)(response);
                }
                return await this.parentMakeRequest(cloudId, userId);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                const error = new Error(`Unable to fetch user: ${err.message}`, {
                    cause: err
                });
                this.onLoadError?.(err);
                throw error;
            }
        };
        this.onLoadError = onLoadError;
        this.parentMakeRequest = super.makeRequest;
    }
}

});
parcelRegister("38H79", function(module, exports) {

$parcel$export(module.exports, "generateUserLink", () => $b826be912fd09914$export$f4673d7e11341514);
$parcel$export(module.exports, "generateTeamLink", () => $b826be912fd09914$export$b163ce931504dcff);
$parcel$export(module.exports, "isTeamProfileCardEventContentRendered", () => $b826be912fd09914$export$6dc006c3779708c0);
$parcel$export(module.exports, "fireLegacyTeamAnalytics", () => $b826be912fd09914$export$ffbbcf55d672ec61);
$parcel$export(module.exports, "restResponseToUserData", () => $b826be912fd09914$export$66691b1affeb3bc5);
$parcel$export(module.exports, "isCustomerAccount", () => $b826be912fd09914$export$67a41405362363f0);
$parcel$export(module.exports, "getSpaActions", () => $b826be912fd09914$export$518f47d656cb4e1a);
$parcel$export(module.exports, "getSpaActionsWithRouterPush", () => $b826be912fd09914$export$96e0a21dc8f6c225);

var $7jTnu = parcelRequire("7jTnu");

var $gCeeo = parcelRequire("gCeeo");

var $9LvIj = parcelRequire("9LvIj");

const $b826be912fd09914$export$f4673d7e11341514 = (userId)=>`/jira/people/${userId}`;
const $b826be912fd09914$export$b163ce931504dcff = (teamId)=>`/jira/people/team/${teamId}`;
const $b826be912fd09914$export$7b55c373f7e07896 = (label, profileUrl)=>({
        id: 'view-profile',
        label: label,
        callback: (event)=>{
            event.stopPropagation();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(profileUrl);
        }
    });
const $b826be912fd09914$export$6dc006c3779708c0 = (analyticsPayload)=>analyticsPayload?.action === 'rendered' && analyticsPayload?.actionSubjectId === 'content';
const $b826be912fd09914$export$ffbbcf55d672ec61 = (analyticsEvent)=>{
    if (analyticsEvent?.payload?.eventType === 'ui') {
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, `legacyTeamProfileCard ${analyticsEvent.payload.action}}`);
        if ($b826be912fd09914$export$6dc006c3779708c0(analyticsEvent?.payload)) (0, $gCeeo.fireScreenAnalytics)(analyticsEvent);
    }
};
const $b826be912fd09914$export$66691b1affeb3bc5 = (userData)=>({
        avatarUrl: userData.avatarUrls?.['48x48'],
        email: userData.emailAddress,
        fullName: userData.displayName,
        isBot: false,
        isCurrentUser: false,
        status: userData.active ? 'active' : 'inactive',
        accountType: userData.accountType
    });
const $b826be912fd09914$export$67a41405362363f0 = (accountId)=>accountId ? accountId.lastIndexOf('qm:', 0) === 0 : false;
const $b826be912fd09914$var$getSpaViewProfileAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $9LvIj.profileCardMessages).viewProfile),
        id: 'view-profile',
        link: `/jira/people/${accountId}`,
        shouldRender: (data)=>/*
   * Those without @atlassian.com accounts do not have viewable profiles
   */ data?.accountType !== 'customer'
    });
const $b826be912fd09914$var$getSpaViewProfileActionWithRouterPush = (intl, accountId, onPushAction, onActionCleanup)=>({
        label: intl && intl.formatMessage((0, $9LvIj.profileCardMessages).viewProfile),
        id: 'view-profile',
        callback: ()=>{
            onPushAction(`/jira/people/${accountId}`);
            onActionCleanup && onActionCleanup();
        },
        link: `/jira/people/${accountId}`,
        shouldRender: (data)=>/*
   * Those without @atlassian.com accounts do not have viewable profiles
   */ data?.accountType !== 'customer'
    });
const $b826be912fd09914$var$getAssignedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $9LvIj.profileCardMessages).assignedIssuesIssueTerminologyRefreshM4 : (0, $9LvIj.profileCardMessages).assignedIssues),
        id: 'assigned-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`assignee="${accountId || ''}" AND resolution is empty`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $b826be912fd09914$var$getReportedIssuesAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $9LvIj.profileCardMessages).reportedIssuesIssueTerminologyRefreshM4 : (0, $9LvIj.profileCardMessages).reportedIssues),
        id: 'reported-issues',
        callback: ()=>{
            const jql = encodeURIComponent(`reporter="${accountId || ''}" order by created DESC`);
            const url = `/issues/?jql=${jql}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $b826be912fd09914$var$getViewFiltersAction = (intl, accountId)=>({
        label: intl && intl.formatMessage((0, $9LvIj.profileCardMessages).viewFilters),
        id: 'view-filters',
        callback: ()=>{
            const url = `/jira/filters?owner=${encodeURIComponent(accountId)}`;
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.open(url, '_blank');
        }
    });
const $b826be912fd09914$export$518f47d656cb4e1a = (accountId, intl, actions)=>{
    if (actions) return actions.map((action)=>{
        switch(action){
            case 0, $6d22448f78a7f25a$export$23cedd3261bd8015:
                return $b826be912fd09914$var$getSpaViewProfileAction(intl, accountId);
            case 0, $6d22448f78a7f25a$export$6bef782d14a92db8:
                return $b826be912fd09914$var$getAssignedIssuesAction(intl, accountId);
            case 0, $6d22448f78a7f25a$export$6b36f20db7a18a86:
                return $b826be912fd09914$var$getReportedIssuesAction(intl, accountId);
            case 0, $6d22448f78a7f25a$export$56da0dd0b0aa67b9:
                return $b826be912fd09914$var$getViewFiltersAction(intl, accountId);
            default:
                throw new Error('unexpected action');
        }
    });
    return [
        $b826be912fd09914$var$getSpaViewProfileAction(intl, accountId)
    ];
};
const $b826be912fd09914$export$96e0a21dc8f6c225 = (accountId, intl, onPushAction, actions, onActionCleanup)=>{
    if (actions) return actions.map((action)=>{
        switch(action){
            case 0, $6d22448f78a7f25a$export$23cedd3261bd8015:
                return $b826be912fd09914$var$getSpaViewProfileActionWithRouterPush(intl, accountId, onPushAction, onActionCleanup);
            case 0, $6d22448f78a7f25a$export$6bef782d14a92db8:
                return $b826be912fd09914$var$getAssignedIssuesAction(intl, accountId);
            case 0, $6d22448f78a7f25a$export$6b36f20db7a18a86:
                return $b826be912fd09914$var$getReportedIssuesAction(intl, accountId);
            case 0, $6d22448f78a7f25a$export$56da0dd0b0aa67b9:
                return $b826be912fd09914$var$getViewFiltersAction(intl, accountId);
            default:
                throw new Error('unexpected action');
        }
    });
    return [
        $b826be912fd09914$var$getSpaViewProfileActionWithRouterPush(intl, accountId, onPushAction, onActionCleanup)
    ];
};

});
parcelRegister("9LvIj", function(module, exports) {

$parcel$export(module.exports, "profileCardMessages", () => $8d56fb88e7ef3ba6$export$49f2d2ccb123fddf);

var $7qGN1 = parcelRequire("7qGN1");
const $8d56fb88e7ef3ba6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    view: {
        "id": "profilecard-next",
        "defaultMessage": "View profile"
    }
});
const $8d56fb88e7ef3ba6$export$49f2d2ccb123fddf = (0, $7qGN1.defineMessages)({
    assignedIssues: {
        "id": "profilecard-next.assigned-issues",
        "defaultMessage": "Assigned issues"
    },
    viewProfile: {
        "id": "profilecard-next.view-profile",
        "defaultMessage": "View profile"
    },
    reportedIssues: {
        "id": "profilecard-next.reported-issues",
        "defaultMessage": "Reported issues"
    },
    viewFilters: {
        "id": "profilecard-next.view-filters",
        "defaultMessage": "View filters"
    },
    assignedIssuesIssueTerminologyRefreshM4: {
        "id": "profilecard-next.assigned-issues-issue-terminology-refresh-m4",
        "defaultMessage": "Assigned work items"
    },
    reportedIssuesIssueTerminologyRefreshM4: {
        "id": "profilecard-next.reported-issues-issue-terminology-refresh-m4",
        "defaultMessage": "Reported work items"
    }
});

});





parcelRegister("28Csj", function(module, exports) {

$parcel$export(module.exports, "ProfileCardView", () => $64d7fb877670625a$export$da5098f02f405a40);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $caeqU = parcelRequire("caeqU");

var $22c3C = parcelRequire("22c3C");
var $hrodw = parcelRequire("hrodw");

var $hjf2q = parcelRequire("hjf2q");

var $6XJko = parcelRequire("6XJko");

var $8q7lT = parcelRequire("8q7lT");

var $kEUB1 = parcelRequire("kEUB1");

var $16TBK = parcelRequire("16TBK");

const $64d7fb877670625a$var$PEOPLE_PROFILE_PATH = '/people/';
const $64d7fb877670625a$var$ProfileCardTriggerWithAnalytics = (0, $hjf2q.AnalyticsEventToProps)((0, $b9c60665faffac50$export$a1455360a24a2234), {
    analytics: ''
})((0, $caeqU.default));
const $64d7fb877670625a$export$da5098f02f405a40 = ({ children: children, position: position = 'top-start', trigger: trigger = 'hover', accountId: accountId, actions: actions, onProfileClick: onProfileClick, addFlag: addFlag, dismissFlag: dismissFlag, testId: testId, prepopulatedData: prepopulatedData, ariaHideProfileTrigger: ariaHideProfileTrigger, isChildComment: isChildComment, shouldTruncate: shouldTruncate })=>{
    const profileCardWrapperRef = (0, $eJOHy.useRef)(null);
    const cloudId = (0, $kEUB1.useCloudId)();
    const viewingUserId = (0, $8q7lT.useAccountId)();
    const { profileClient: profileClient } = (0, $16TBK.useProfileClient)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($64d7fb877670625a$var$Wrapper, {
        ref: profileCardWrapperRef,
        onClick: (event)=>{
            if (profileCardWrapperRef?.current !== null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            !profileCardWrapperRef?.current?.contains(event.target)) event.stopPropagation();
        },
        "data-vc": `profilecard-wrapper${false ? '-ssr' : ''}`,
        isVisualRefresh: (0, $6XJko.isVisualRefreshEnabled)(),
        className: (0, $hcewu.default)([
            isChildComment && "_kqswh2mm _1hjgt94y _1pty1eak _161e1v33 _ft5qdlk8 _2wzdc71f _2kncueha _qlwiueha _aetrb3bt _631ousvi _18postnw _g0nf1yie _15l21pz7 _z0aiduof _1hfk1w7a _1e9pu2gc _1qdg1osq",
            isChildComment && "_p12f1kdh _kqswh2mm _uglpt94y _161e1v33 _1pty1eak _2knc163p _qlwi163p _631ousvi _aetrb3bt _18postnw _g0nf1yie _15l24uri _z0aiduof _1hfk1w7a _1e9pu2gc _1qdg1osq",
            shouldTruncate && "_1reo15vq _18m915vq _1o9zidpf _1bto1l2s _o5721q9c"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($64d7fb877670625a$var$ProfileCardTriggerWithAnalytics, {
        cloudId: cloudId,
        userId: accountId,
        resourceClient: profileClient,
        position: position,
        trigger: trigger,
        testId: testId,
        actions: actions,
        reportingLinesProfileUrl: $64d7fb877670625a$var$PEOPLE_PROFILE_PATH,
        prepopulatedData: prepopulatedData,
        onReportingLinesClick: // @ts-expect-error - TS7006 - Parameter 'user' implicitly has an 'any' type.
        onProfileClick ? (user)=>onProfileClick(user.accountIdentifier) : null,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        addFlag: (flag)=>{
            const flagId = (0, $hrodw.toFlagId)(flag.id);
            addFlag({
                id: flagId,
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $22c3C.default), {
                        ...flag,
                        onDismissed: ()=>{
                            dismissFlag(flagId);
                        },
                        ...props
                    })
            });
        },
        viewingUserId: viewingUserId,
        ariaHideProfileTrigger: ariaHideProfileTrigger
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": "profilecard-next.ui.profilecard.profilecard-trigger",
        className: (0, $hcewu.default)([
            shouldTruncate && "_1e0c1nu9"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64d7fb877670625a$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisualRefresh: isVisualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_p12f1osq",
            __cmplp.isVisualRefresh && "_syaz1gjq",
            __cmplp.className
        ])
    });
});
const $64d7fb877670625a$var$profileCardStyles = null;
const $64d7fb877670625a$var$replyProfileCardStyles = null;
const $64d7fb877670625a$var$truncatedProfileCardStyles = null;
const $64d7fb877670625a$var$truncatedProfileCardInnerStyles = null;
$64d7fb877670625a$var$Wrapper.displayName = 'Wrapper';

});
parcelRegister("caeqU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9b60a56512bd43f$export$2e2bcd8739ae039);


var $1GAK3 = parcelRequire("1GAK3");

var $39Fdj = parcelRequire("39Fdj");
var $f9b60a56512bd43f$export$2e2bcd8739ae039 = (0, $39Fdj.default);

});
parcelRegister("1GAK3", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $500dc3728366069c$export$403d297463f226af);

var $eJOHy = parcelRequire("eJOHy");

const $500dc3728366069c$export$403d297463f226af = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2ly6c")));

});
parcelRegister("2ly6c", function(module, exports) {

let $1b57fe43f319ccc2$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $1b57fe43f319ccc2$var$load("ffQaD"),
    $1b57fe43f319ccc2$var$load("kvRbA"),
    $1b57fe43f319ccc2$var$load("2wjWj")
]).then(()=>parcelRequire('k60Oj'));

});


parcelRegister("39Fdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a556daa2b306b37$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $ftN6c = parcelRequire("ftN6c");

var $7m76n = parcelRequire("7m76n");
var $XUWry = parcelRequire("XUWry");

var $eGOwo = parcelRequire("eGOwo");

var $kJsb4 = parcelRequire("kJsb4");

var $IW7jS = parcelRequire("IW7jS");

var $gh6xW = parcelRequire("gh6xW");

var $8WJ7D = parcelRequire("8WJ7D");

var $b4A0H = parcelRequire("b4A0H");

var $2EPX4 = parcelRequire("2EPX4");


var $bQmsU = parcelRequire("bQmsU");

var $1GAK3 = parcelRequire("1GAK3");

var $5H2ec = parcelRequire("5H2ec");
function $9a556daa2b306b37$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, viewingUserId: viewingUserId, trigger: trigger, product: product, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
    if (isAgent) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bQmsU.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        viewingUserId: viewingUserId,
        trigger: trigger,
        product: product,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag
    });
    else return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1GAK3.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        })
    });
}
function $9a556daa2b306b37$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions, ariaHideProfileTrigger: ariaHideProfileTrigger = false, isVisible: propsIsVisible, ssrPlaceholderId: ssrPlaceholderId }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isMounted = (0, $eJOHy.useRef)(false);
    const showDelay = trigger === 'click' || propsIsVisible && (0, $eGOwo.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $776ef75d5b01ad48$export$5b956b542f1bc1b3);
    const hideDelay = trigger === 'click' || propsIsVisible && (0, $eGOwo.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $776ef75d5b01ad48$export$89a9f35a94d7f196);
    const showTimer = (0, $eJOHy.useRef)(0);
    const hideTimer = (0, $eJOHy.useRef)(0);
    const [visible, setVisible] = (0, $eJOHy.useState)(false);
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(undefined);
    const [hasError, setHasError] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [data, setData] = (0, $eJOHy.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $eJOHy.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $eJOHy.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $eJOHy.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $eJOHy.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eJOHy.useState)(false);
    const triggerRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $eJOHy.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $2EPX4.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $eJOHy.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $eJOHy.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setTeamCentralBaseUrl(teamCentralBaseUrl);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $eJOHy.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $eJOHy.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos(),
                resourceClient.getTeamCentralBaseUrl({
                    withOrgContext: true,
                    withSiteContext: true
                })
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $eJOHy.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $eJOHy.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $2EPX4.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $eJOHy.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $2EPX4.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $2EPX4.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $eJOHy.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $eGOwo.fg)('fix_profilecard_trigger_isvisible')) return;
        // If the prop isVisible is not defined, we don't want to do anything
        if (propsIsVisible === undefined) return;
        // If the prop isVisible is defined, we want to show or hide the profile card based on the value
        if (propsIsVisible) showProfilecard();
        else hideProfilecard();
    }, [
        hideProfilecard,
        propsIsVisible,
        showProfilecard
    ]);
    const containerListeners = (0, $eJOHy.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $eJOHy.useCallback)(()=>{
        return (0, $gh6xW.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $eJOHy.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: userId === viewingUserId,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    const ssrPlaceholderProp = (0, $eGOwo.fg)('cc_mention_ssr_placeholder') ? {
        'data-ssr-placeholder-replace': ssrPlaceholderId
    } : {};
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
                isOpen: !!visible,
                onClose: (event)=>{
                    hideProfilecard();
                    handleKeyboardClose(event);
                },
                placement: position,
                offset: offset ?? [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                        ...wrapperProps,
                        children: showLoading ? /*#__PURE__*/ (0, $gt9Am.jsx)($9a556daa2b306b37$var$LoadingView, {
                            fireAnalytics: fireAnalytics
                        }) : visible && /*#__PURE__*/ (0, $gt9Am.jsx)($9a556daa2b306b37$var$ProfileCardContent, {
                            profilecardProps: profilecardProps,
                            isAgent: !!data?.isAgent,
                            userId: userId,
                            cloudId: cloudId,
                            resourceClient: resourceClient,
                            viewingUserId: viewingUserId,
                            trigger: trigger,
                            product: product,
                            profileCardAction: filterActions(),
                            errorType: error,
                            hasError: hasError,
                            agentActions: agentActions,
                            addFlag: addFlag
                        })
                    }),
                trigger: (triggerProps)=>{
                    const { ref: callbackRef, ...innerProps } = triggerProps;
                    const ref = (element)=>{
                        triggerRef.current = element;
                        if (typeof callbackRef === 'function') callbackRef(element);
                    };
                    const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                        ...disabledAriaAttributes ? restInnerProps : triggerProps,
                        ...containerListeners,
                        ref: ref,
                        "data-testid": testId,
                        ...!ariaHideProfileTrigger && {
                            'aria-labelledby': ariaLabelledBy
                        },
                        ...disabledAriaAttributes ? {} : {
                            role: 'button',
                            //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                            tabIndex: ariaHideProfileTrigger ? -1 : 0,
                            'aria-label': ariaHideProfileTrigger ? undefined : (0, $8WJ7D.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                        },
                        ...ariaHideProfileTrigger && {
                            'aria-hidden': 'true'
                        },
                        ...ssrPlaceholderProp,
                        children: children
                    });
                },
                zIndex: (0, $IW7jS.layers).modal(),
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: autoFocus ?? trigger === 'click',
                // This feature gate is currently enabled only for Jira_Web to avoid UI issues in Confluence_Web.
                shouldRenderToParent: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card'),
                shouldDisableFocusLock: (0, $eGOwo.fg)('enable_appropriate_reading_order_in_profile_card')
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7m76n.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $XUWry.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
}
const $9a556daa2b306b37$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.CardWrapper), {
        testId: "profilecard.profilecardtrigger.loading",
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5H2ec.default), {
            fireAnalytics: fireAnalytics
        })
    });

});
parcelRegister("7m76n", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $ec00209f14041f24$export$93fe397a02fe8b76);

var $eJOHy = parcelRequire("eJOHy");

const $ec00209f14041f24$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("lWqKn")));

});
parcelRegister("lWqKn", function(module, exports) {

let $ff93c327b9f5ea83$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $ff93c327b9f5ea83$var$load("76n7a"),
    $ff93c327b9f5ea83$var$load("l253H"),
    $ff93c327b9f5ea83$var$load("ffQaD"),
    $ff93c327b9f5ea83$var$load("kvRbA"),
    $ff93c327b9f5ea83$var$load("2tv8I")
]).then(()=>parcelRequire('3dj1A'));

});


parcelRegister("XUWry", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $2c3b135763fda18f$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $2c3b135763fda18f$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $2c3b135763fda18f$export$7a1fc1a1b0477464);
var $2c3b135763fda18f$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    KudosType["MIXED"] = "mixed";
    return KudosType;
}({});
var $2c3b135763fda18f$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
const $2c3b135763fda18f$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($2c3b135763fda18f$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("gh6xW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4adbe5caf86a5ece$export$2e2bcd8739ae039);
const $4adbe5caf86a5ece$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $4adbe5caf86a5ece$export$2e2bcd8739ae039 = $4adbe5caf86a5ece$var$filterActions;

});

parcelRegister("8WJ7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a2772a88ae71e4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $95a2772a88ae71e4$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($95a2772a88ae71e4$var$messages.label, {
        fullName: fullName
    }) : formatMessage($95a2772a88ae71e4$var$messages.fallbackLabel);
};
const $95a2772a88ae71e4$var$messages = (0, $7qGN1.defineMessages)({
    fallbackLabel: {
        id: 'profilecard.user.trigger.fallback-aria-label',
        defaultMessage: 'More information about this user',
        description: 'Label for profile card trigger when we do not have user name'
    },
    label: {
        id: 'profilecard.user.trigger.aria-label',
        defaultMessage: 'More information about {fullName}',
        description: 'Label for profile card trigger'
    }
});
var $95a2772a88ae71e4$export$2e2bcd8739ae039 = $95a2772a88ae71e4$var$getLabelMessage;

});

parcelRegister("b4A0H", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $d37aab7a36a1d923$export$6aa22a823032b784);
$parcel$export(module.exports, "SpinnerContainer", () => $d37aab7a36a1d923$export$a5e06607a5ac6158);
/* UserTrigger.tsx generated by @compiled/babel-plugin v0.36.1 */ // PLEASE NOTE: This file is sync-loaded with the trigger components. Only add components here that
// are necessary for the main render of the trigger component to help maintain bundle size.
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
const $d37aab7a36a1d923$var$styles = {
    cardWrapper: "_2rkoglpi _1bsb1gwv",
    spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm"
};
const $d37aab7a36a1d923$export$6aa22a823032b784 = ({ children: children, role: role, testId: testId, labelledBy: labelledBy })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($d37aab7a36a1d923$var$styles.cardWrapper),
        backgroundColor: 'elevation.surface.overlay',
        role: role,
        testId: testId,
        "aria-labelledby": labelledBy,
        children: children
    });
const $d37aab7a36a1d923$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        xcss: (0, $6qaBj.cx)($d37aab7a36a1d923$var$styles.spinnerContainer),
        children: children
    });

});

const $776ef75d5b01ad48$export$5b956b542f1bc1b3 = 800;
const $776ef75d5b01ad48$export$89a9f35a94d7f196 = 200;

parcelRegister("bQmsU", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardResourced", () => $2dca9d01bdb4de20$export$4b013ffffcb40af8);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $eGOwo = parcelRequire("eGOwo");

var $j19W0 = parcelRequire("j19W0");

var $2EPX4 = parcelRequire("2EPX4");

var $46Rs7 = parcelRequire("46Rs7");

var $dWlMJ = parcelRequire("dWlMJ");

var $kKboJ = parcelRequire("kKboJ");

var $5TZsz = parcelRequire("5TZsz");
const $2dca9d01bdb4de20$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $eJOHy.useState)();
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [error, setError] = (0, $eJOHy.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireAnalytics = (0, $eJOHy.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $2EPX4.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $eJOHy.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $46Rs7.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const { href: profileHref } = (0, $j19W0.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    const getCreator = (0, $eJOHy.useCallback)(async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: (0, $eGOwo.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $eJOHy.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileData = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireAnalytics);
            const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireAnalytics,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kKboJ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dWlMJ.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: ()=>{}
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5TZsz.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            isCreatedByViewingUser: creatorUserId === props.viewingUserId,
            product: props.product,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId
        })
    });
};

});
parcelRegister("46Rs7", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $5342ced741c59880$export$3761e66a04602cbd);
const $5342ced741c59880$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $5342ced741c59880$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($5342ced741c59880$export$470b0d72e4fdc43a, '');
};

});

parcelRegister("dWlMJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4c4e00d9fd0e109$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $a03qM = parcelRequire("a03qM");

var $jZF1f = parcelRequire("jZF1f");

var $5qJVF = parcelRequire("5qJVF");

var $3CCXY = parcelRequire("3CCXY");

var $2EPX4 = parcelRequire("2EPX4");
const $d4c4e00d9fd0e109$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $eJOHy.useEffect)(()=>{
        fireAnalytics((0, $2EPX4.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3CCXY.ErrorTitle), {
            children: "The user is no longer available for the site"
        });
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3CCXY.ErrorTitle), {
            children: [
                "Oops, looks like we\u2019re having issues",
                /*#__PURE__*/ (0, $gt9Am.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5qJVF.default), {
                    color: "color.text.subtlest",
                    children: "Try again and we\u2019ll give it another shot"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3CCXY.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
                label: "icon error",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jZF1f))),
                LEGACY_size: "xlarge"
            }),
            errorContent(),
            reload && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5CSKW.default), {
                onClick: reload,
                children: "Try again"
            })
        ]
    });
};
var $d4c4e00d9fd0e109$export$2e2bcd8739ae039 = $d4c4e00d9fd0e109$var$ErrorMessage;

});
parcelRegister("3CCXY", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", () => $f4fe046f369d0d86$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $f4fe046f369d0d86$export$b065fd053267ec81);
$parcel$export(module.exports, "TeamErrorText", () => $f4fe046f369d0d86$export$90d92ccfb27352c6);
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
const $f4fe046f369d0d86$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_11c82smr _syaz1fxt _19pku2gc",
    teamErrorText: "_syaz1wmz _19pku2gc"
};
const $f4fe046f369d0d86$export$bb27b7e39840238f = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.errorWrapper),
        ...props
    });
const $f4fe046f369d0d86$export$b065fd053267ec81 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.errorTitle),
        children: props.children
    });
const $f4fe046f369d0d86$export$90d92ccfb27352c6 = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($f4fe046f369d0d86$var$styles.teamErrorText),
        children: props.children
    });

});


parcelRegister("kKboJ", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardWrapper", () => $d15bd5f3ea87f8ed$export$2c6604b50c274e6f);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $d15bd5f3ea87f8ed$var$styles = (0, $1DXK0.xcss)({
    width: '360px'
});
const $d15bd5f3ea87f8ed$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8nu6j.default), {
        xcss: $d15bd5f3ea87f8ed$var$styles,
        children: children
    });
};

});

parcelRegister("5TZsz", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardLazy", () => $aff86c6979038d17$export$ed0ca9c1d49ea0bf);

var $eJOHy = parcelRequire("eJOHy");

const $aff86c6979038d17$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("2XXEr")));

});
parcelRegister("2XXEr", function(module, exports) {

let $228f5cf7f6ecd638$var$load = (parcelRequire("gLHA4"))(4);
module.exports = Promise.all([
    $228f5cf7f6ecd638$var$load("76n7a"),
    $228f5cf7f6ecd638$var$load("l253H"),
    $228f5cf7f6ecd638$var$load("ffQaD"),
    $228f5cf7f6ecd638$var$load("kvRbA"),
    $228f5cf7f6ecd638$var$load("gsod0")
]).then(()=>parcelRequire('e1nCN'));

});



parcelRegister("5H2ec", function(module, exports) {

$parcel$export(module.exports, "default", () => $75ec444a04f48b56$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");

var $b4A0H = parcelRequire("b4A0H");

var $2EPX4 = parcelRequire("2EPX4");
const $75ec444a04f48b56$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $eJOHy.useEffect)(()=>{
        fireAnalytics((0, $2EPX4.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b4A0H.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {})
    });
};
var $75ec444a04f48b56$export$2e2bcd8739ae039 = $75ec444a04f48b56$var$UserLoadingState;

});



const $b9c60665faffac50$export$a1455360a24a2234 = 'profileCardNextView';




$parcel$global.rlb("f5PLD")
//# sourceMappingURL=async-profile-card-next.e4bace02.js.map
